import { EntityListSkuResponse, EntityListTypeName } from '@ydistri/api-sdk';
import { EntityListTypeGroup } from './skuEntityListsTypes';

export const getEntityListGroups = (
  entityLists: EntityListSkuResponse[],
): EntityListTypeGroup[] => {
  const groupMap = new Map<EntityListTypeName, EntityListSkuResponse[]>();

  for (const entityList of entityLists) {
    const typeNames = entityList.entityListTypes.map(elt => elt.entityListTypeName);

    typeNames.forEach(typeName => {
      const existing = groupMap.get(typeName);
      if (existing) {
        existing.push(entityList);
      } else {
        groupMap.set(typeName, [entityList]);
      }
    });
  }

  return Array.from(groupMap.entries())
    .map(([type, lists]) => ({ type, lists }))
    .sort((a, b) => a.type.localeCompare(b.type));
};
